import axios from "axios";
import {hostWithPrefix} from "../../Features/Constructor/common/ApiCommon";

/**
 * Отправляем на бэк запрос на поиск единицы измерения по параметрам в request
 * @param request - содержит начало и конец времени поиска,
 * айди источника данных и краткое имя метеокода
 * @returns найденная единица измерения, если не найдена, то пустая строчка
 */
export function findUnit(request) {
    return axios({
        url: 'http://' + hostWithPrefix +
            '/unit/time?meteocode=' + request.mcode,
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
        request: request,
        responseType: 'json',
    })
}